module.exports = __webpack_public_path__ + "static/media/08_CALCINHA_ASA_DELTA_ESTAMPADA_02.93c24b61.jpg";